import { memo, useState } from "react";
import Total from "app/pages/.shared/PriceSummary/Total/Total";
import Button, {
	BUTTON_ICON_ALIGNMENTS,
	BUTTON_SIZES,
	BUTTON_VARIANTS,
} from "app/pages/.shared/form/Button";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./FlexRateItem.scss";
import Amount from "app/pages/.shared/AmountContainer";
import { INSURANCE_STANDARD } from "app/constants";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import IconFlex from "app/pages/.shared/IconFlex";
import Loader from "app/pages/.shared/Loader";
import { htmlSanitize } from "app/utils/sanitize";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const FlexRateFlex = ({ insurance, total, handleClick, disabled, loading, upgradePrice }) => {
	const [isSubmitNoFlex, setIsSubmitNoFlex] = useState(false);
	return (
		<div className="flex-rate-item flex-rate-item--flex">
			<div className="flex-rate-item__title">
				<IconFlex />
				<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold component="h3">
					<FormattedMessage id="flex.rate.modal.flex.title" />
					<Amount amount={upgradePrice} prefix="+" />
				</Typography>
			</div>
			<div className="flex-rate-item__description">
				<FormattedMessage id="flex.rate.modal.flex.description" />
			</div>
			<div className="flex-rate-item__border" />
			<div className="flex-rate-item__content">
				<div className="flex-rate-item__list">
					<div
						className="list"
						dangerouslySetInnerHTML={{ __html: htmlSanitize(insurance.details) }}
					/>
				</div>
				<div className="flex-rate-item__footer">
					<div className="flex-rate-item__total">
						<Total total={total} />
					</div>
					<Button
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						disabled={disabled}
						loading={loading && !isSubmitNoFlex}
						onClick={() => {
							handleClick(insurance);
						}}
						data-testid="quote-flex-button"
						icon={<IconRight />}
						alignIcon={BUTTON_ICON_ALIGNMENTS.RIGHT}
						label={<FormattedMessage id="flex.rate.modal.flex.btn.label" />}
					/>
					<div
						className="flex-rate-item__no-flex"
						onClick={() => {
							setIsSubmitNoFlex(true);
							handleClick({ code: INSURANCE_STANDARD });
						}}
					>
						{loading && isSubmitNoFlex ? (
							<Loader width={50} height={50} />
						) : (
							<FormattedMessage id="flex.rate.modal.no.flex" />
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

FlexRateFlex.propTypes = {
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
	total: PropTypes.number,
	upgradePrice: PropTypes.number,
	handleClick: PropTypes.func,
	insurance: PropTypes.object,
};

export default memo(FlexRateFlex);
